import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from "rxjs";

import {InputChannel} from "@app/shared/connect/connect.component";


export interface ConnectMessage {
  show: boolean;
}


@Injectable()
export class ConnectService {
  getSub: Subject<ConnectMessage> = new Subject();
  getObs = this.getSub.asObservable();

  constructor(private http: HttpClient) {
  }


  getContacts(mode: string): Observable<any[]> {
    const url = `/connect/channels?contactChannel.channelType=${mode}&acceptStatus=Accepted`;
    return this.http.get<any[]>(url);
  }

  getRequests(mode: string): Observable<any> {
    const url = `/connect/channels?contactChannel.channelType=${mode}&acceptStatus=Pending`;
    return this.http.get<any>(url);
  }

  postContact(channel: InputChannel) {
    const url = `/connect/channels`;
    return this.http.post<any>(url, channel);
  }

  postNewChannelMember(newMember) {
    const url = `/connect/channel-members`;
    return this.http.post<any>(url, newMember);

  }

  getChannelMember(memberId) {
    const url = `/connect/channel-members/${memberId}`;
    return this.http.get<any>(url);
  }

  getZoomVideoURL(topic, callType): Observable<any> {
    const url = `/connect/zoom?topic=${topic}&type=${callType}`;
    return this.http.get<any>(url);
  }

  getZoomVideoURLV2(topic, userId, callType): Observable<any> {
    const url = `/connect/zoomCall?topic=${topic}&userId=${userId}&type=${callType}`;
    return this.http.get<any>(url);
  }

  createZoomUser(email): Observable<any> {
    const url = `/connect/zoomuser?email=${email}`;
    return this.http.get<any>(url);
  }

  deleteNewZoomUser(email): Observable<any> {
    const url = `/connect/zoomuser?email=${email}`;
    return this.http.delete<any>(url);
  }

  updateChannelMember(updatedMember) {
    let id = updatedMember['id'];
    const url = `/connect/channel-members/${id}`;
    return this.http.put<any>(url, updatedMember);

  }

  updateGroup(channel) {
    let id = channel['id'];
    console.log(channel);
    const url = `/connect/channels/${id}`;
    return this.http.put<any>(url, channel);
  }

  deleteChannel(id) {
    const url = `/connect/channels/${id}`;
    return this.http.delete(url);
  }

}
